import { motion } from "framer-motion";
import { FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";

export default function Footer() {
  const linkVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <footer className="relative bg-gradient-to-br from-[#0b1b4d] to-[#1a2a5e] text-gray-300 overflow-hidden">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url('data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')`,
        }}
      ></div>

      <div className="relative max-w-7xl mx-auto px-6 py-16">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-4 gap-12 items-start"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          <motion.div variants={linkVariants}>
            <div className="flex items-center gap-3">
              <span className="text-xl font-extrabold text-white tracking-tight">
                Ekamdhyas
              </span>
            </div>
            <p className="mt-4 text-sm text-gray-400 max-w-sm leading-relaxed">
              Empowering structured learning through innovative courses,
              real-world internships, and personalized mentorship.
            </p>
          </motion.div>

          <motion.div variants={linkVariants}>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-gray-400">
              Explore
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {[
                { name: "Home", href: "/" },
                { name: "Courses", href: "/courses" },
                { name: "Internships", href: "/internships" },
              ].map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div variants={linkVariants}>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-gray-400">
              Contact
            </h4>

            <ul className="mt-2 space-y-2 text-sm">
              <li className="flex flex-col gap-1">
                <span className="font-semibold text-gray-400">Email:</span>
                <a
                  href="mailto:ekamdhyassoftware@gmail.com"
                  className="text-gray-200 hover:text-white transition-colors duration-200 break-all"
                >
                  ekamdhyassoftware@gmail.com
                </a>
              </li>

              <li className="flex flex-col gap-1">
                <span className="font-semibold text-gray-400">Phone:</span>
                <div className="flex flex-wrap gap-x-2">
                  <a
                    href="tel:+919175559400"
                    className="text-gray-200 hover:text-white transition-colors duration-200"
                  >
                    +91 91755 59400
                  </a>
                  <span className="text-gray-500">/</span>
                  <a
                    href="tel:+919595957778"
                    className="text-gray-200 hover:text-white transition-colors duration-200"
                  >
                    +91 95959 58887
                  </a>
                </div>
              </li>

              <li className="flex flex-col gap-1">
                <span className="font-semibold text-gray-400">Location:</span>
                <span className="text-gray-200 leading-relaxed">
                  N-9, K-2/3, CIDCO, Chh. Sambhajinagar, Maharashtra 431003
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div variants={linkVariants}>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-gray-400">
              Follow Us
            </h4>
            <div className="mt-4 flex space-x-4">
              <a
                href="https://linkedin.com/company/ekamdhyas"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <FaLinkedin size={20} />
              </a>
              <a
                href="https://twitter.com/ekamdhyas"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Twitter"
              >
                <FaTwitter size={20} />
              </a>
              <a
                href="https://instagram.com/ekamdhyas"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          className="mt-10 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        />

        <motion.div
          className="mt-4 flex flex-col md:flex-row items-center justify-between text-xs text-gray-400 gap-2"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          <p>© {new Date().getFullYear()} Ekamdhyas. All rights reserved.</p>
          <div className="flex space-x-4">
            <a
              href="/privacy"
              className="hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="hover:text-white transition-colors duration-200"
            >
              Terms of Service
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
}
